// HowItWorksComponent.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import recover from '../assets/recover.png';
import bank from '../assets/bank.png';
import plan from '../assets/plan.png';
import caseImg from '../assets/case.png';

const steps = [
  {
    id: 1,
    title: 'Eligibility Check & Strategy',
    description: 'A 5–10 minute intake clarifies your goal (work, study, family, PR, visit) and destination. We confirm eligibility, outline the best route, fees, documents, and a realistic timeline.',
    image: caseImg,
  },
  {
    id: 2,
    title: 'Documents & Application Pack',
    description: 'We provide a tailored document list, templates (SOP/letters), and translation/apostille guidance. Your forms and supporting evidence are compiled and quality-checked before submission.',
    image: plan,
  },
  {
    id: 3,
    title: 'Submission, Biometrics & Interview',
    description: 'We lodge online or coordinate VAC/embassy filing, book biometrics, and prep you for interviews. You\'ll get status tracking and proactive updates.',
    image: bank,
  },
  {
    id: 4,
    title: 'Decision, Travel & Next Steps',
    description: 'On approval, we share travel/arrival checklists and local registrations (where applicable). If refused, we reassess options or prepare an appeal with licensed counsel where required.',
    image: recover,
  },
];

const HowItWorksComponent = () => {
  return (
    <section className="mx-4 md:mx-24 bg-acBg py-8 md:py-20 px-8 md:px-16 rounded-3xl mt-4 md:mt-16">
      <h2 className="text-2xl md:text-3xl font-bold font-inter text-acBlack mb-4">How It Works</h2>
      <p className="text-md text-acGray font-light mb-8">We guide you from eligibility to arrival-clearly, quickly, and compliantly.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {steps.map((step) => (
          <motion.div 
            key={step.id} 
            className="flex space-x-4 items-start py-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: step.id * 0.2 }}
            viewport={{ once: true }}
          >
            <img src={step.image} alt={step.title} className="w-8 md:w-36 " />
            <div>
              <h3 className="font-bold text-acBlack">{step.id}. {step.title}</h3>
              <p className="text-acGray text-sm font-light">{step.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
      <div className="mt-8 md:mt-12 flex justify-center">
        <Link 
          to="/contact" 
          className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-8 py-3 rounded-lg transition-colors"
        >
          Check your eligibility
        </Link>
      </div>
    </section>
  );
};

export default HowItWorksComponent;
